module.exports = __webpack_public_path__ + "img/back-icon05.e0aae782.png";